import { deTranslations } from './de';

export const resources = {
  de: deTranslations,
};
